<template>
    <div v-if="client_id && !hidden" class="flex w-full justify-content-left gap-2">
        <Button label="Документы" @click="showDialog" :loading="loading" :disabled="loading" 
            class="flex white-space-nowrap text-xs" icon="pi pi-plus" outlined size="small" severity="secondary"/>
        
        <Button v-if="doc_id" label="Статус KYC" @click="CheckKycStatus" :loading="loading" :disabled="loading" 
            class="flex white-space-nowrap text-xs" icon="pi pi-check" outlined size="small" severity="secondary"/>
    </div>

    <Dialog class="flex flex-column border-none" modal
        v-model:visible="dialog"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: '900px' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Добавить клиента</span>
            </div>
        </template>

        <div class="flex flex-column w-full gap-4">
            <!-- Выбор типа верификации -->
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-md font-medium">Тип верификации:</span>
                <Select v-model="verificationType" :options="verificationOptions" optionLabel="label" optionValue="value" placeholder="Выберите тип" class="w-full md:w-14rem" />
            </div>
            <!-- Фото документа -->
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-md font-medium">Фото документа:</span>
                <div v-if="filesDocument.length>0" class="flex w-full gap-2">
                    <div v-for="file in filesDocument" :key="file.id" 
                        class="flex flex-column gap-2 p-2 border-1 surface-border border-round-lg w-6rem">
                        <div class="flex flex-column">
                            <img :src="file.url" v-if="file.url && (file.mimetype=='image/png' || file.mimetype=='image/jpg' || file.mimetype=='image/jpeg')" 
                                class="w-full border-1 surface-border border-round-lg mt-2" />
                        </div>
                        <div class="flex flex-row align-items-start gap-2">
                            <RadioButton :inputId="'doc-'+file.id" :value="file.id" v-model="selectedDocumentId" />
                            <!-- <label :for="'doc-'+file.id" class="text-xs">Выбрать</label> -->
                            <!-- <Button icon="pi pi-copy" @click="copy(file.id)" outlined rounded severity="info" size="small" /> -->
                        </div>
                    </div>
                </div>
                <UploadFiles :multiple="false" :maxFiles="2" :data="{client_id: client_id, from: 'user', type: 'document'}"
                    @onUpload="files => upload(files, 'document')" @onReset="() => resetFiles('document')" @onLoading="setLoading" />
            </div>

            <!-- Фото с лицом -->
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-md font-medium">Фото с лицом:</span>

                <div v-if="filesFace.length>0" class="flex w-full gap-2">
                    <div v-for="file in filesFace" :key="file.id" 
                        class="flex flex-column gap-2 p-2 border-1 surface-border border-round-lg w-6rem">
                        <div class="flex flex-column">
                            <img :src="file.url" v-if="file.url && (file.mimetype=='image/png' || file.mimetype=='image/jpg' || file.mimetype=='image/jpeg')" 
                                class="w-full border-1 surface-border border-round-lg mt-2" />
                        </div>
                        <div class="flex flex-row align-items-start gap-2">
                            <RadioButton :inputId="'face-'+file.id" :value="file.id" v-model="selectedFaceId" />
                        </div>
                    </div>
                </div>

                <UploadFiles :multiple="false" :maxFiles="2" :data="{client_id: client_id, from: 'user', type: 'face'}"
                    @onUpload="files => upload(files, 'face')" @onReset="() => resetFiles('face')" @onLoading="setLoading" />
            </div>

            <!-- Фото страницы прописки -->
            <div class="flex flex-column w-full gap-2">
                <span class="flex text-md font-medium">Фото страницы прописки:</span>
                <div v-if="filesRegistration.length>0" class="flex w-full gap-2">
                    <div v-for="file in filesRegistration" :key="file.id"
                        class="flex flex-column gap-2 p-2 border-1 surface-border border-round-lg w-6rem">
                        <div class="flex flex-column">
                            <img :src="file.url" v-if="file.url && (file.mimetype=='image/png' || file.mimetype=='image/jpg' || file.mimetype=='image/jpeg')"
                                class="w-full border-1 surface-border border-round-lg mt-2" />
                        </div>
                        <div class="flex flex-row align-items-start gap-2">
                            <RadioButton :inputId="'registration-'+file.id" :value="file.id" v-model="selectedRegistrationId" />
                        </div>
                    </div>
                </div>
                <UploadFiles :multiple="false" :maxFiles="2" :data="{client_id: client_id, from: 'user', type: 'registration'}"
                    @onUpload="files => upload(files, 'registration')" @onReset="() => resetFiles('registration')" @onLoading="setLoading" />
            </div>
        </div>

        <template #footer>
            <Button label="Отправить на KYC" @click='SendToKYC()' :loading="loading" :disabled="loading || !selectedDocumentId || !selectedFaceId || !verificationType" 
                class="flex" icon="pi pi-arrow-right" size="large" severity="info"/>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import UploadFiles from '@/components/public/upload_files.vue'

export default {
    props: {
        client_id: {
            type: String,
            required: true
        },
        doc_id: {
            type: String,
            default: null
        },
        hidden: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            dialog: false,
            files: [],
            kycStatus: null,
            kycStatusLoading: false,
            selectedDocumentId: null,
            selectedFaceId: null,
            verificationType: null,
            verificationOptions: [
                { label: 'Beorg', value: 'default' },
                { label: 'Авангард', value: 'avangard' }
            ],
        }
    },
    components: {
        UploadFiles,
    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
        filesDocument() {
            return this.files.filter(f => f.type === 'document')
        },
        filesFace() {
            return this.files.filter(f => f.type === 'face')
        },
        filesRegistration() {
            return this.files.filter(f => f.type === 'registration')
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        showDialog(){
            this.dialog = true
            this.GetPersonalFiles()
        },
        async GetPersonalFiles() {
            const resFiles = await this.connect.GetPersonalFiles(100, 0, {client_id: this.client_id}).then(res=>res)
            if(resFiles.result) {
                // Если в файлах нет поля type, по умолчанию считаем type: 'document'
                this.files = resFiles.data.map(f => f)
            } 
        },
        async SendToKYC(){
            if (!this.selectedDocumentId || !this.selectedFaceId) {
                this.showMess('error', 'Ошибка', 'Выберите файл документа и файл с лицом');
                return;
            }
            if (!this.verificationType) {
                this.showMess('error', 'Ошибка', 'Выберите тип верификации');
                return;
            }
            let selectedRegistration = this.filesRegistration.length > 0 ? this.filesRegistration[0].id : null;
            if (this.verificationType === 'easy_pay' && !selectedRegistration) {
                this.showMess('error', 'Ошибка', 'Для Easy Pay требуется загрузить фото страницы прописки');
                return;
            }
            const data = {
                client_id: this.client_id,
                verification_type: this.verificationType,
                document_file_id: this.selectedDocumentId,
                face_file_id: this.selectedFaceId,
                registration_file_id: selectedRegistration
            }
            this.loading = true
            try{
                // Передаем выбранные ID файлов и тип верификации
                const add = await this.connect.PersonalSendToKyc(data).then(res=>res)
                if(add.result && add.data){
                    this.showMess('success', 'Успешно', 'Клиент добавлен')
                    this.dialog = false
                } else {
                    if(add.message){
                        this.showMess('error', 'Ошибка', add.message)
                    } else {
                        this.showMess('error', 'Ошибка', 'Ошибка при добавлении клиента')
                    }
                } 
            } catch(e){
                this.showMess('error', 'Ошибка', 'Ошибка при добавлении клиента')
                console.log('error', e)
            }  
            this.loading = false
        },
        async CheckKycStatus() {
            if (!this.client_id) {
                this.showMess('error', 'Ошибка', 'Нет client_id');
                return;
            }
            this.loading = true;
            try {
                const res = await this.connect.PersonalKycStatus(this.client_id).then(res=>res)
                if (res && res.result) {
                    let statusMsg = res.data && res.data.status ? res.data.status : JSON.stringify(res.data);
                    this.showMess('success', 'Статус KYC', statusMsg);
                } else {
                    this.showMess('warn', 'KYC', res.message || 'Не удалось получить статус');
                }
            } catch (e) {
                this.showMess('error', 'Ошибка', 'Ошибка при получении статуса KYC');
            }
            this.loading = false;
        },
        upload(files, fileType) {
            if(!files) return
            if(files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    // file._id - это объект файла, возможно, нужно добавить type
                    if(file._id) {
                        let newFile = { ...file._id, type: fileType }
                        this.files.push(newFile)
                    }
                }
            }
        },
        resetFiles(fileType) {
            // Оставляем только файлы другого типа
            this.files = this.files.filter(f => f.type !== fileType)
        },
        setLoading(val){
            this.loading = val
        },
    },
    async mounted() {

    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>